import { render, staticRenderFns } from "./SoftwaresPanel.vue?vue&type=template&id=1852c658&"
import script from "./SoftwaresPanel.vue?vue&type=script&lang=js&"
export * from "./SoftwaresPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports